import * as React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import _ from "underscore";
import { MenuItem, MenuItemProps } from '../../menu/menuitem';
import { Profile } from '../../../store/Profile/Profile';
import { ConnectedProfileList } from '../connected/connected.profilelist';
import { BaseList } from '../../base/baseList';

export interface ProfileSelectionModalProps {
    selectedProfiles?: Array<Profile>;
    isModalOpen: boolean;
    profileList: React.ReactElement;
    refreshListOnView?: boolean;
}

export interface ProfileSelectionCallbacks {
    onConfirm: () => void;
    toogleModal: () => void;
    onViewList?: () => JQueryPromise<boolean>;
    onRemoveSelected: (id: string) => void;
}

enum ViewType {
    List,
    SelectedList
}

interface ProfileSelectionState {
    viewType: ViewType;
}

export class ProfileSelectionModal extends React.Component<ProfileSelectionModalProps & ProfileSelectionCallbacks, ProfileSelectionState> {

    constructor(props) {
        super(props);
        this.state = {
            viewType: ViewType.List
        }
    }

    private switchView(viewType: ViewType) {

        if (this.props.refreshListOnView) {
            if (viewType == ViewType.List) {
                this.props.onViewList().then(res => {
                    if (res == true)
                        this.setState({ viewType: viewType });
                });
                return;
            }
        }
        this.setState({ viewType: viewType });
    }

    private getSelectedList(): JSX.Element[] {

        return this.props.selectedProfiles.map(profile => {

            let roleName = profile.account !== undefined && profile.account != null
                && profile.account.role !== undefined && profile.account.role != null ? profile.account.role.name : "-";

            return (
                <tr key={profile.id} style={{ cursor: "pointer" }} onClick={() => { }}>
                    <td>
                        {profile.lastName} {profile.firstName}
                    </td>
                    <td>
                        {profile.email}
                    </td>
                    <td>
                        {profile.phone}
                    </td>
                    <td className="d-none d-md-table-cell">
                        {roleName}
                    </td>
                    <td>
                        <div>
                            <span onClick={() => this.props.onRemoveSelected(profile.id)} style={{ height: "25px", width: "25px", display: "inline-block", position: "relative" }}>
                                <i style={{ position: "relative", left: "5px" }} className="fas fa-trash fa-1x"></i>
                            </span>
                        </div>
                    </td>
                </tr >
            );
        });
    }

    private getHead(): JSX.Element {

        return (
            <thead>
                <tr className="text-eurorounders">
                    <th>Nome</th>
                    <th className="d-none d-md-table-cell">Email</th>
                    <th className="d-none d-md-table-cell">Tel.</th>
                    <th className="d-none d-md-table-cell">Ruolo</th>
                    <th className="d-none d-md-table-cell"></th>
                </tr>
            </thead>
        );

    }

    private getBody(): JSX.Element {

        switch (this.state.viewType) {
            case ViewType.List:
                return (
                    <React.Fragment>
                        {this.props.profileList}
                    </React.Fragment>
                );
            case ViewType.SelectedList:

                return (
                    <React.Fragment>
                        <BaseList
                            hasNextPage={false}
                            list={this.props.selectedProfiles}
                            getHead={() => this.getHead()}
                            getElements={(list) => this.getSelectedList()}
                            active={false}
                        />
                    </React.Fragment>
                )
        }

        return null;
    }

    private getButtons(): JSX.Element {
        switch (this.state.viewType) {
            case ViewType.SelectedList:
                return (
                    <React.Fragment>
                        <MenuItem isSmall={true} isButton={true} icon="bars" label="Lista" onClick={() => this.switchView(ViewType.List)} />
                        <MenuItem isSmall={true} isButton={true} icon="check" label="Conferma" onClick={() => { this.props.onConfirm(); this.props.toogleModal(); }} />
                    </React.Fragment>
                );
            case ViewType.List:
                return (
                    <React.Fragment>
                        <MenuItem isSmall={true} isButton={true} icon="user-check" label={this.props.selectedProfiles !== undefined && this.props.selectedProfiles != null ? this.props.selectedProfiles.length.toString() : "0"} onClick={() => this.switchView(ViewType.SelectedList)} />
                        <MenuItem isSmall={true} isButton={true} icon="check" label="Conferma" onClick={() => { this.props.onConfirm(); this.props.toogleModal(); }} />
                    </React.Fragment>
                );
        }

        return null;
    }

    render() {

        let body = this.getBody();
        let buttons = this.getButtons();
        return (
            <Modal className="bg-dark modal-lg" isOpen={this.props.isModalOpen} toggle={() => this.props.toogleModal()} backdrop="static">
                <ModalHeader className="text-eurorounders bg-dark" toggle={() => this.props.toogleModal()}>Seleziona Utenti</ModalHeader>
                <ModalBody className="bg-dark text-eurorounders">
                    {body}
                </ModalBody>
                <ModalFooter>
                    {buttons}
                    <MenuItem isSmall={true} isButton={true} icon="times" label="Annulla" onClick={() => this.props.toogleModal()} />
                </ModalFooter>
            </Modal>
        );
    }
}